import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
export default {
	all:{
		jiantizhongwen:'Simplified Chinese',
		fantizhongwen: 'Traditional Chinese',
		yingwen: 'English',
		ribenyu:'Japanese',
		hanguoyu:'Korean',
		jizhuzhanghao:'Remember account',
		jizhumima:'Remember password',
		yuyanxuanze: 'Language selection',
		shezhi: 'setting',
		xiugaimima: 'Change password',
		yinsizhengce: 'Privacy Policy',
		guanyuwomen: 'About Us',
		mimashuoming: 'The password must consist of a combination of 8-20 characters, including uppercase and lowercase letters and numbers, and cannot be composed solely of numbers or letters',
		qingshurujiumima: 'Please enter your old password',
		qingshuruxinmima: 'Please enter a new password',
		quedingxiugai: 'Confirm modification',
		
		shouye: 'Home Page',
		zhibo: 'live broadcast',
		wode: 'my',
		xitongxiaoxi: 'System',
		wodedingdan: 'Order',
		bangzhufankui: 'Feedback',
		xiugaiziliao: 'Modify profile',
		xiaofeimingxi: 'Consumption Details',
		zhibojilu: 'Live broadcast record',
		tijiao: 'Submit',
		caozuochenggong: 'Operation successful',
		tishi: 'prompt',
		quedingtuichudengluma:'Are you sure you want to log out?',
		queding: 'confirm',
		wentibangzhu: 'Question Help',
		woyaofankui: 'I want to give feedback',
		fankuiwenti: 'feedback issue',
		qingmiaoshuniyaofankuidewenti:'Please describe the problem you want to feedback...',
		sousuo: 'search',
		sousuoniganxingqudeneirong: 'Search for content that interests you',
		zhibojianbiaoti: 'live stream title',
		zhibojianbeijing: 'Live streaming room background',
		xuanzebackground: 'Select Background',
		shangchuanbeijing: 'Upload Background',
		yixuanze: 'Selected',
		qingxuanzebeijing: 'Please select background',
		xietongzhiboweiqidong: 'Co-live function not activated',
		zhibojianbiaoqian: 'live streaming room tag',
		zhibojianhuazhi: 'live streaming video quality',
		geinidezhibojianqugemingziba: 'Give your live streaming room a name~',
		qingshurukaibomiyao: 'Please enter the broadcast secret key',
		kaishizhibo: 'Start live streaming',
		shengyin: 'sound',
		liwutexiao: 'gift special effect',
		gengduo: 'more',
		gouwuche: 'shopping cart',
		zaixianguanzhong:'online audience',
		danmushuoming:'The platform strictly prohibits minors from recharging and tipping, as well as inducing tipping through private transactions such as playing together. It also strictly prohibits content related to pornography, politics, abuse, etc. Please pay attention to property safety, beware of online fraud, and consume rationally',
		tianjiaguanliyuan: 'Add administrator',
		jinyan: 'mute',
		jiechuejinyan: 'lift the mute',
		tichufangjian: 'kick out of the room',
		shangpinxiangqing: 'Product Details',
		lijijiagou:'Add to Cart Now',
		xuanzeguige: 'Select specification',
		quanbuliwu: 'All gifts',
		ge: 'a',
		bi: 'coin',
		guanliyuan: 'administrator',
		kuaijieduanyu: 'Quick Phrases',
		gonggao: 'Announcement',
		xinzengkuaijieduanyu: 'New quick phrases',
		qingshuru: 'Please input',
		qingshuruzhengque: 'Please enter a valid amount',
		shuru: 'Input',
		wangjimima: 'Forgot password',
		youxiangzhuce: 'Email registration',
		huoquyanzhengma: 'Obtain verification code',
		qingshuruningdeyouxiangzhanghao:'Enter your email account',
		qingshuruyanzhengma: 'Please enter the verification code',
		qingshurumima: 'Please enter your password',
		mimadenglu: 'Password login',
		woyiyuedubingtongyi:'I have read and agree',
		yonghuxieyi: 'User Agreement',
		yinsixieyi: 'Privacy Agreement',
		denglu: 'login',
		chongxindenglu: 'Log in again',
		xiayibu: 'Next step',
		haimeizhanghao: 'I do not have an account yet',
		quzhuce:"go register",
		yiyouzhanghao: 'Already have an account',
		qudenglu: 'Go to login',
		shezhijibenxinxi: 'Set basic information',
		nichengtishi: 'Only letters, numbers, and punctuation marks are supported. It must be at least 6 characters long and cannot contain spaces.',
		shezhiyonghuming: 'Set username',
		yonghumingtishi: 'The username should be 6-18 characters long, consisting of uppercase and lowercase letters or numbers',
		shezhijiaoyimima: 'Set transaction password',
		jiaoyimimatishi: 'The transaction password must consist of a combination of 6 digits',
		qingxuanze: 'Please choose',
		yaoqingma:'Invitation code (optional)',
		qingshuruyaoqingma: 'Enter invitation code',
		shezhixinmima: 'Set new password',
		xuanzeningdeguojia: 'Select your country',
		zhuce: 'register',
		qingshuruyonghuming: 'Please enter your username',
		gaoqinghuazhi: 'high-definition picture quality',
		biaoqinghuazhi: 'Standard definition',
		chaoqinghuazhi: 'Ultra HD',
		putonghuazhi: 'Normal picture quality',
		kaishizhibo: 'Start live streaming',
		zengsong:'Give',
		jinrulezhibojian: 'Enter the live streaming room',
		shuodianshenmene:'What do you want to say ...',
		zanwushuju: 'No data available',
		songgei:'give to',
		huifang:'playback',
		xunibi:'virtual currency',
		quanbu:'all',
		appxiazai:'Download',
		dingdanjine: 'Order amount',
		dingdanbianhao: 'Order number',
		chuangjianshijian: 'creation time',
		zhubozanshilikai: 'The host is temporarily away',
		mashanghuilai: 'I will be back soon',
		guojianzhuoxiazai: 'International Android Download',
		anzhuoxiazai: 'Android download',
		guojipingguoxiazai: 'International Apple Download',
		pingguoxiazai: 'Apple download',
		quanbushangpin:"all products",
		yiqiangguang: 'All sold out',
		jiagou: 'add cart',
		shangpinxiangqing: 'Product Details',
		lijijiagou:"immediately add to cart",
		yixuan: 'Selected',
		xuanzeguiige: 'Select Specification',
		xuazeguige: 'Select specification',
		shangchuanzhong: 'Uploading',
		shangchuanshibai: 'Upload failed',
		browserbu支持: 'Your browser does not support media device access',
		qingkaiqi: 'Please enable camera and microphone permissions',
		meiyoushebei: 'No camera or microphone device detected',
		shebeibeizhan: 'Device is occupied by another program, please close it and try again',
		quxianchengong: 'Failed to obtain media permission',
		shifouquedingjieshuzhibo: 'Are you sure to close the live broadcast?',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'Please read and agree to the User Agreement and Privacy Agreement!',
		quedingqudengluma: 'Are you sure you want to log in?',
		duanyingyin:'Short Video',
		fabuduanyingyin:'Publish Short Video',
		zhibohuaxu:'Live Highlights',
		qingshurubiaoti:'Please enter title',
		shangchuanduanyingyin:'Upload Short Video',
		zhibozhongxin:'Live Center',
		zongzichanguzhi:'Total Asset Value',
		liushuijilu:'Transaction History',
		chongbi:'Deposit',
		tibi:'Withdraw',
		dashang:'Tips',
		riqi:'Date',
		leixing:'Type',
		miaoshu:'Description',
		jine:'Amount',
		zhuangtai:'Status',
		yiwancheng:'Completed',
		shenhezhong:'Pending',
		shenhejujue:'Rejected',
		kaishiriqi:'Start Date',
		jieshuriqi:'End Date',
		wangluo:'Network',
		dizhi:'Address',
		tibishuliang:'Withdrawal Amount',
		daozhangshisuan:'Arrival Estimate',
		shouxufei:'Fee',
		meiridaozhang:'Daily Arrival',
		keyong:'Available',
		dongjie:'Frozen',
		zuixiaotibishuliang:'Min Withdrawal',
		shouxufeibilv:'Fee',
		meirishenyueddu:'Daily Remaining Limit',
		shenqingzhibo:'Apply for Live',
		shenqingjilu:'Application Records',
		huifangjilu:'Replay Records',
		yikaifang:'Open',
		guankanhuifang:'Watch Replay',
		beisu:'Speed',
		zhiboriqi:'Live Date',
		shijianshiduan:'Time Slot',
		shoujizhibo:'Mobile Live',
		zhibodaihuo:'Live Shopping',
		kaiqi:'On',
		guanbi:'Off',
		beizhu:'Remark',
		huodongzhuti:'Theme, equipment description',
		shenqinghouliucheng:'Post-application Process',
		shenqinghouliuchengdesc:'After approval, a confirmation email with the live stream address will be sent.',
		daishenhe:'Pending',
		tijiaoshenqing:'Submit Application',
		qingxuanzeriqi:'Please select a live date',
		qingxuanzeshijian:'Please select a time slot',
		tijiaochenggong:'Submitted successfully',
		nian:'/',
		yue:'',
		tongshiduanbukezhongfu:'No duplicate time slots',
		keshenqingshiduan:'Available Time Slots',
		querenShiduan:'Confirm',
		zhanghaoid:'Account ID',
		qingtianxie:'Please fill in',
		zhou1:'Mon',
		zhou2:'Tue',
		zhou3:'Wed',
		zhou4:'Thu',
		zhou5:'Fri',
		zhou6:'Sat',
		zhou7:'Sun',
		shenqingyitijiao:'Application Submitted',
		shenqingtijiaodesc:'The admin will review the room, time slot, and product info.',
		chakanshenheJilu:'View Review Records',
		shenqingriqi:'Apply Date',
		zhiboshijianduan:'Live Time Slot',
		zhiboleixing:'Live Type',
		daihuo:'Shopping',
		yitongguo:'Approved',
		weitongguo:'Rejected',
		xiangqing:'Details',
		yuanyin:'Reason',
		shenqingxiangqing:'Application Details',
		shenheyuanyin:'Review Reason',
		xutiaozheng:'Adjustment Needed',
		shenheyuanyindesc:'The time slot is occupied. Please select a different date or time slot and resubmit.',
		wancheng:'Done',
		chulizhong:'Processing',
		daichuli:'Pending',
		houtaishenhe:'Admin Review',
		chanshengmiyao:'Generate Key',
		youjiankuaidi:'Email Notification',
		kechakan:'Viewable',
		jinwanxinpinfuli:'New product live stream tonight',
		chehuishenqing:'Withdraw Application',
		chongxinshenqing:'Reapply',
		zhibojinyao:'Live Key',
		zhibojian:'Room',
		keyongshiduan:'Available Time',
		youxiao:'Valid',
		tuiliudizhi:'Push URL',
		tuiliumamiyao:'Stream Key',
		youjiantongzhidesc:'Keys will not be regenerated for the same room and time slot.',
		yifasong:'Sent',
		fuzhiquanbu:'Copy All',
		fuzhichenggong:'Copied',
		youjiantongzhi:'Email Notification',
		zhiboshenhetongguo:'Live Approved',
		shoujianren:'Recipient',
		youjianneirongdesc:'Contains room info, available time slots, push/pull stream URLs, keys, and pre-stream settings.',
		youjianbianhao:'Mail ID',
		chongxinfasong:'Resend',
		yinyuedaren:'Music',
		wudaodaren:'Dance',
		yanzhi:'Beauty',
		jichushezhi:'Basic Settings',
		yishangchuan:'Uploaded',
		zhiboshangpin:'Live Products',
		laiziyunimall:'From UNImall Store',
		jian:' items',
		zhiboliucheng:'Live Process',
		liuchang:'Smooth',
		gaoqing:'HD',
		chaoqing:'Ultra HD',
		languang:'Blu-ray',
		tongguo:'Passed',
		jinxingzhong:'In Progress',
		daikaiqi:'Pending',
		qianzhizuoye:'Pre-setup',
		qingshangchuan:'Upload',
		shangpinxuhao:'No.',
		shangpinshoutu:'Image',
		shangpinmingcheng:'Product Name',
		shangchengkucun:'Store Stock',
		zhibokucun:'Live Stock',
		shangchengjiage:'Store Price',
		zhibojiage:'Live Price',
		caozuo:'Action',
		yichu:'Remove',
		zhibojiansetting:'Room Settings',
		kaiqishengyin:'Sound On',
		guanbishengyin:'Sound Off',
		kaiqidanmu:'Danmu On',
		guanbidanmu:'Danmu Off',
		kaiqimeiyan:'Beauty On',
		guanbimeiyan:'Beauty Off',
		kaiqimaikefeng:'Mic On',
		guanbimaikefeng:'Mic Off',
		kaiqimaike:'Mic On',
		guanbimaike:'Mic Off',
		gonggao:'Notice',
		fenxianglianjie:'Share Link',
		xietongzhibo:'Co-live',
		yaoqingjinbo:'Invite Co-host',
		tongyikongzhi:'Unified Control',
		tichuzhubozb:'Remove Selected',
		zhuborenshushangxian:'Co-host Limit',
		ren:'',
		tongzhibojinyao:'Same as Live Key',
		zhuboquanxian:'Co-host Permissions',
		yunxufayan:'Allow Chat',
		yunxukamai:'Allow Mic',
		yunxukashipin:'Allow Video',
		yikaiqi:'Enabled',
		shengchengyaoqingjinyao:'Generate Invite Key',
		xietongzhiborenshu:'Co-live Capacity',
		dangqianzhibo:'Current Co-hosts',
		kenenghaiyaoqing:'Can invite',
		weizhibo:' more',
		baocunshangxian:'Save Limit',
		fenxiangyaoqing:'Share Invite',
		yaoqinglianjie:'Invite Link',
		fenxiangfangshi:'Share Method',
		fuzhilianjie:'Copy Link',
		baocunerweima:'Save QR Code',
		fuzhiyaoqinglianjie:'Copy Invite Link',
		zhubo:'Co-host',
		guanli:'Manage',
		yijinru:'Joined',
		maikefeng:'Microphone',
		shexiangtou:'Camera',
		sheweizhuyemian:'Set as Main',
		quxiaozhuyemian:'Cancel Main',
		tichuzhibo:'Remove from Room',
		tichuhoubukejinru:'Cannot re-enter after removal',
		tongyikongmai:'Unified Mic Control',
		quanjukongzhi:'Global Control',
		quantijingyin:'Mute All',
		yunxuzhubokaimai:'Allow Co-host Mic',
		yunxuzhubokaishipin:'Allow Co-host Video',
		huifukaimai:'Unmute',
		guanbishipin:'Disable Video',
		kaiqishipin:'Video On',
		yunxushipin:'Allow Video',
		yingyongshezhi:'Apply Settings',
		shipin:'Video',
	kaimai:'Mic On',
	weikaiqi:'Off',
	shipinkaiqi:'Video On',
	shipinguanbi:'Video Off',
	bimai:'Mute',
	yunxufayan:'Allow Chat',
	jinzhifayan:'Disallow Chat',
	zhuboxiwei:'Co-host Seat',
		guankanzhibo:'Watch Live',
		goumai:'Buy',
		goumaishangpin:'Buy Product',
		yishouqing:'Sold Out',
		qianggou:'Buy Now',
		dashang:'Reward',
		chakangg:'Notice',
		quxiao:'Cancel',
		queren:'Confirm',
		wodequanbao:'My Wallet',
		jiangjie:'Explain',
		jiangjiezhong:'Explaining',
		kucun:'Stock',
		qrcodenotexist:'QR Code not found',
		qrcodesaved:'QR Code saved successfully',
		wodeqianbao:'My Wallet',
		lianshangbaobishibei:'On-chain Token',
		zonge:'Total',
		keyongshuliang:'Available',
		dongjieshuliang:'Frozen',
		chakanliushui:'View Transactions',
		chongzhitip:'Only same-chain transfers supported. Blockchain confirmed transfers are irreversible.',
		chongzhishuliang:'Deposit Amount',
		yujidaozhang:'Estimated Arrival',
		shijidaozhang:'Actual Received',
		lijichongzhi:'Deposit Now',
		chongzhierweima:'Deposit QR Code',
		chongbidizhi:'Deposit Address',
		fuzhidizhi:'Copy Address',
		chongzhichenggong:'Deposit Success',
		chongbichenggong:'Deposit Successful',
		bizhong:'Token',
		shuliang:'Amount',
		shijian:'Time',
		tibidizhi:'Withdrawal Address',
		tibishisuan:'Withdrawal Estimate',
		zuiditixianjin:'Minimum withdrawal amount',
		meiriyushutixian:'Daily remaining withdrawal amount',
		keyongyu:'Available balance',
		tijiaotibi:'Submit Withdrawal',
		xuanzetibidizhi:'Select Withdrawal Address',
		sousuodizhi:'Search address',
		xuanze:'Select',
		querentbi:'Confirm Withdrawal',
		xuanzedashangbizhong:'Select Reward Token',
		yue:'Balance',
		dashangjine:'Reward Amount',
		zhanshidashangxinxi:'Show reward information',
		zidingyi:'Custom',
		querendashang:'Confirm Reward',
		zaixianguanzhong:'Viewers',
		yizhibo:'Live',
		jieshizhibo:'End Live',
		zhibozhong:'Live',
		zanwuzaixianguanzhong:'No viewers online',
		shangchuanshibai:'Video upload failed, please try again later',
		qingshurucontent:'Please fill in the title and upload the video',
		fabuchenggong:'Publish successful',
		fabushibai:'Publish failed',
		qingshurushuju:'Please enter data',
		confirmDelete:'Confirm delete this video?',
		shanchuchenggong:'Delete successful',
		confirmWithdraw:'Confirm withdraw this video?',
		chehuichenggong:'Withdraw successful',
		yongjiujinyan:'Permanent Ban',
		jiaruzhibo:'Join Live',
		jiaruxietongzhibo:'Join Co-live',
		tuichuxietongzhibo:'Exit Co-live',
		zhubojinyao:'Co-host Key',
		qingshuruzhubojinyao:'Please enter co-host key',
		jiaru:'Join',
		shenqingchenggong:'Application successful',
		youxiaoqi:'Validity Period',
		tichubenchang:'Kick Out',
		zhanshidashangxiaoxi:'Show Tip Messages',
		zanwugonggao:'No Notice',
		dashang:'Tip',
		songgei:'sent',
		ge:'',
		bi:'tokens',
		zanweiyourenjiaruxietongzhibo:'No one has joined the co-live yet',
		zanweikaiqi:'Co-live streaming is not enabled yet'
	},
}
 


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js